import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IPaginatedResponse} from "../../request/IResponse";
import {propertyListConstraints} from "../constants/property_list_constraints";
import {IGetPropertyListPayload} from "../types/GetPropertyListPayload";

type IGetPropertiesCountPayload = Omit<IGetPropertyListPayload, "page_size">;

const propertyListApiLink = apiV2Link.property.list(Scenario.PROPERTY_LIST);

export const getPropertiesCount = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getPropertiesCount: build.query<IPaginatedResponse["count"], IGetPropertiesCountPayload>({
            query: (params) => ({
                url: propertyListApiLink,
                params: {
                    ...propertyListConstraints,
                    ...params,
                    page_size: 0
                }
            }),
            transformResponse: (response: IPaginatedResponse) => {
                return response.count;
            }
        })
    })
});

export const {useGetPropertiesCountQuery} = getPropertiesCount;
import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IPaginatedResponse} from "../../request/IResponse";
import {propertyListConstraints} from "../constants/property_list_constraints";
import {IGetPropertyListPayload} from "../types/GetPropertyListPayload";

type IGetPropertiesCountPayload = Omit<IGetPropertyListPayload, "page_size">;

const propertyListApiLink = apiV2Link.property.list(Scenario.PROPERTY_LIST);

export const getPropertiesCount = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getPropertiesCount: build.query<IPaginatedResponse["count"], IGetPropertiesCountPayload>({
            query: (params) => ({
                url: propertyListApiLink,
                params: {
                    ...propertyListConstraints,
                    ...params,
                    page_size: 0
                }
            }),
            transformResponse: (response: IPaginatedResponse) => {
                return response.count;
            }
        })
    })
});

export const {useGetPropertiesCountQuery} = getPropertiesCount;
